module.exports = __webpack_public_path__ + "static/media/degree_left-1.8d284548.png";